export const ORDER_NOT_FOUND_MESSAGE = 'Order not found';
export const BARCODES_FETCH_ERROR_MESSAGE = 'Failed to fetch barcodes';

export const FILTERED_COLUMN_NAME = 'stainName';
